<template lang="pug">
CustomBtn.ShareBtn(@click="share"): svg(viewBox="0 0 110 94"  xmlns="http://www.w3.org/2000/svg")
  path(d="M72 56a16 16 0 00-12 5.5L39.5 51.4a16 16 0 000-6.7L60 34.5A16 16 0 0088 24a16 16 0 10-31.6 3.3L36 37.5A16 16 0 008 48a16 16 0 0028 10.5l20.4 10.2A16 16 0 1072 56zm0-40a8 8 0 110 16 8 8 0 010-16zM24 56a8 8 0 110-16 8 8 0 010 16zm48 24a8 8 0 110-16 8 8 0 010 16z")
</template>

<script>
import CustomBtn from '@/components/CustomBtn'

export default {
  name: 'ShareBtn',
  props: {
    title: { type: String, default: document.title },
    text: { type: String, default: '' },
    url: { type: String, default: window.location.origin },
    via: { type: String, default: 'rezozero' }
  },
  components: { CustomBtn },
  methods: {
    getWindowOptions () {
      const width = 500
      const height = 350
      const left = (window.innerWidth / 2) - (width / 2)
      const top = (window.innerHeight / 2) - (height / 2)

      return [
        'resizable,scrollbars,status',
        'height=' + height,
        'width=' + width,
        'left=' + left,
        'top=' + top
      ].join()
    },
    async share (e) {
      e.preventDefault()
      if (navigator.share) {
        await navigator.share({ title: this.title, text: this.text, url: this.url })
      } else {
        const shareUrl = `https://twitter.com/intent/tweet?url=${this.url}&text=${encodeURIComponent(this.text)}&via=${this.via}`
        const win = window.open(shareUrl, 'ShareOnTwitter', this.getWindowOptions())
        win.opener = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ShareBtn {
  cursor: pointer;
  height: 57px;
  width: 57px;
  border-radius: 50%;
  border: solid 1px rgba($white, 0.5);
  color: $white;
  background: none;
}
</style>
